import React from 'react';
import { motion } from 'framer-motion';
import { FaEdit, FaTrash, FaEye, FaEyeSlash } from 'react-icons/fa';

const BlogTagCard = ({
    tag,
    onEdit,
    onDelete,
    onToggleStatus
}) => {
    const handleEdit = (e) => {
        e.stopPropagation();
        onEdit && onEdit(tag);
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete && onDelete(tag);
    };

    const handleToggleStatus = (e) => {
        e.stopPropagation();
        onToggleStatus && onToggleStatus(tag);
    };

    return (
        <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow duration-200 cursor-pointer"
        >
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                    <div className="w-4 h-4 rounded-full flex-shrink-0" style={{ backgroundColor: tag.color }}></div>
                    <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-semibold text-gray-900 truncate">{tag.name}</h3>
                    </div>
                </div>
                <div className="flex items-center space-x-1 flex-shrink-0 ml-2">
                    <button
                        onClick={handleToggleStatus}
                        className={`p-1.5 rounded-full transition-colors ${tag.is_active
                            ? 'text-green-600 hover:bg-green-50'
                            : 'text-gray-400 hover:bg-gray-50'
                            }`}
                        title={tag.is_active ? 'Deactivate' : 'Activate'}
                    >
                        {tag.is_active ? <FaEye size={12} /> : <FaEyeSlash size={12} />}
                    </button>
                    <button
                        onClick={handleEdit}
                        className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
                        title="Edit"
                    >
                        <FaEdit size={12} />
                    </button>
                    <button
                        onClick={handleDelete}
                        className="p-1.5 text-red-600 hover:bg-red-50 rounded-full transition-colors"
                        title="Delete"
                    >
                        <FaTrash size={12} />
                    </button>
                </div>
            </div>

            <div className="flex items-center justify-between text-sm text-gray-500">
                <div className="flex items-center space-x-2">
                    <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs">
                        Order: {tag.order}
                    </span>
                    <span className={`px-2 py-1 rounded-full text-xs ${tag.is_active
                        ? 'bg-green-100 text-green-800'
                        : 'bg-gray-100 text-gray-800'
                        }`}>
                        {tag.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>
                <div className="text-xs text-gray-400">
                    {new Date(tag.created_at).toLocaleDateString()}
                </div>
            </div>
        </motion.div>
    );
};

export default BlogTagCard;
